import { memo } from "react";
import { Button } from "antd";
import { useTranslation } from "react-i18next";
import { RollbackOutlined } from "@ant-design/icons";
import classname from "classname";

const Revert = ({
  id,
  title,
  icon = <RollbackOutlined />,
  type = "primary",
  disabled = false,
  btnClassName,
  ...props
}) => {
  const { t } = useTranslation();
  const btnTitle = title ? title : t("button.cancel");
  return (
    <Button
      className={classname(
        `border-0 justify-center items-center flex hover:opacity-70 ${btnClassName}`,
        {
          "bg-orange1": !disabled,
        }
      )}
      id={id}
      type={type}
      icon={icon}
      disabled={disabled}
      {...props}
    >
      {btnTitle}
    </Button>
  );
};

export default memo(Revert);
